import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ec-modal',
  templateUrl: './ec-modal.component.html',
  styleUrls: ['./ec-modal.component.scss'],
  standalone: false
})
export class ECModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ECModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) { dialogRef.disableClose = true; }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onConfirm() {
    this.dialogRef.close(true);
  }

}
